<template>
  <div class="filter">
    <div class="filter__title">
      <div>
        <span>Фильтры</span>
        <FilterIcon class="filter-icon__filter" />
        <transition name="fade" mode="out-in">
          <div v-if="!isOpen && selectCounter" class="filter__title--counter">
            {{ selectCounter }}
          </div>
        </transition>
      </div>
      <div @click="() => (isOpen = !isOpen)">
        <span>{{ isOpen ? 'Свернуть' : 'Развернуть' }}</span>
        <ArrowUpIcon
          class="filter-icon__arrow"
          :class="[!isOpen && '--rotate']"
        />
      </div>
    </div>
    <transition name="fadeHeight" mode="out-in">
      <div v-if="isOpen" style="margin-top: 12px">
        <slot></slot>
        <div v-if="clearble" class="filter__clear">
          <div @click="$emit('clear')">
            <CloseRoundIcon class="clear-icon" />
            <span>Очистить все фильтры</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import { useDisplay } from '@/hooks'

import FilterIcon from '@/assets/icons/filter'
import ArrowUpIcon from '@/assets/icons/arrow-up'
import CloseRoundIcon from '@/assets/icons/close-round'

export default {
  name: 'SmFilter',
  props: ['clearble', 'selectCounter'],
  components: { FilterIcon, ArrowUpIcon, CloseRoundIcon },
  setup() {
    const display = useDisplay()
    const isOpen = ref(!display.value.smAndDown)

    return {
      isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style.scss';
</style>
